// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2itBZ","row":"Node_row__3YgQN","label":"Node_label__39pew","footer":"Node_footer__1bbgq"};